import React, {useEffect, useRef, useState} from 'react'
import Loading from "components/Loading";
import PurchasingGroupStage1Service from "services/PurchasingGroupStage1Service";
import MembersDocumentsList from "./MembersDocumentsList";
import {connect} from "react-redux";
import SimpleTable from "components/complex/simpleTable/SimpleTable";
import Tr from "translations/Translations";
import {makeStyles} from "@material-ui/styles";
import TitledComponent from "components/TitledComponent";
import WorkableIconDeleteButton from "components/button/WorkableIconDeleteButton";
import Button from "components/Button";
import AddIcon from "@material-ui/icons/AddBoxOutlined";
import AddMemberUserPopup from "./AddMemberUserPopup";
import {confirmComplex} from "libs/ConfirmNotification";
import BoldTypography from "components/BoldTypography";
import PurchasingGroupSectionService from "services/PurchasingGroupSectionService";
import {getUserFullNameWithEmail} from "libs/userNameGetter";
import {PurchasingGroupStageSections} from "../../../../constants/PurchasingGroupStageSections";
import WorkableButton from "components/button/WorkableButton";
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import CancelIcon from '@material-ui/icons/Cancel';
import DemandValidationMessages from "components/DemandValidationMessages";
import UserService from "services/UserService";
import scheduleReloadTimeout from "../../../../utils/scheduleReloadTimeout";
import GridBlock from "components/GridBlock";
import Typography from "components/Typography";

const useStyle = makeStyles(theme => ({
    lpColumn: theme.components.table.lpColumn,
    buttonColumn: theme.components.table.buttonColumn,
    addButton: {
        marginLeft: theme.spacing(2)
    },
    section: {
        marginTop: theme.spacing(2)
    },
    success: {
        color: theme.palette.success.dark,
        marginLeft: theme.spacing()
    },
    italic: {
        fontStyle: 'italic'
    }

}))

function MembersElementContent(
    {
        groupId,
        member,
        coordinatorView,
        editable,
        memberData,
        validationSection,
        stage1Sections
    }) {
    const classes = useStyle();
    const [addPopup, setAddPopup] = useState(false);
    const [deleteWorkingId, setDeleteWorkingId] = useState(0);
    const [participationWorking, setParticipationWorking] = useState(false);
    const rejected = member.rejectionDate !== null;
    const timeout = useRef(0)


    const getMember = () => {
        if (timeout.current) {
            clearTimeout(timeout.current);
            timeout.current = 0;
        }
        PurchasingGroupStage1Service.getMember(groupId, member.identity)

        const mainSection = stage1Sections[PurchasingGroupStageSections.STAGE_1_SECTION];
        if (mainSection && mainSection.schedule) {
            UserService.serverTime().then(serverTime => {
                let reloadTimeout = scheduleReloadTimeout(mainSection.schedule, serverTime);
                if (reloadTimeout) {
                    timeout.current = setTimeout(() => {
                        getMember();
                    }, reloadTimeout)
                }
            })
        }
    }

    useEffect(() => {
        getMember();
        return () => {
            if (timeout.current) {
                clearTimeout(timeout.current);
                timeout.current = 0;
            }
            PurchasingGroupStage1Service.clearResources(PurchasingGroupStage1Service.PURCHASING_GROUP_MEMBER_RESOURCE_ID(member.identity))
        }
        // eslint-disable-next-line
    }, [])

    const doDelete = (user) => {
        setDeleteWorkingId(user.identity)
        PurchasingGroupStage1Service.deleteMemberUser(groupId, member.identity, user.identity).finally(() => {
            PurchasingGroupSectionService.getSections(groupId, PurchasingGroupStageSections.MEMBERS)
            setDeleteWorkingId(0);
        });
    }

    const withdrawParticipation = () => {
        setParticipationWorking(true);
        PurchasingGroupStage1Service.withdrawParticipationMember(groupId, member.identity).then(
            ()=> PurchasingGroupSectionService.getSections(groupId, PurchasingGroupStageSections.MEMBERS)
        ).finally(() => setParticipationWorking(false));
    }

    const confirmParticipation = () => {
        setParticipationWorking(true);
        PurchasingGroupStage1Service.confirmParticipationMember(groupId, member.identity).then(
            ()=> PurchasingGroupSectionService.getSections(groupId, PurchasingGroupStageSections.MEMBERS)
        ).finally(() => setParticipationWorking(false));
    }

    if (!memberData)
        return <Loading/>
    return (<div>
        {coordinatorView && <DemandValidationMessages editable={validationSection.editable} section={validationSection}/>}
        <TitledComponent
            className={classes.section}
            title={Tr('purchasing_group_users')}
            additionalElement={coordinatorView ? undefined :
                <Button disabled={!editable} onClick={() => setAddPopup(true)} className={classes.addButton} Icon={AddIcon}
                        variant="outlined">{Tr('purchasing_group_users_add')}</Button>}>
            {
                memberData.users.length === 0 ?
                    <>
                        <Typography className={classes.italic} color="primary">{Tr('purchasing_group_users_not_added')}</Typography>
                    </>
                    :
                    <SimpleTable
                        columnClasses={[
                            classes.lpColumn,
                            undefined,
                            classes.buttonColumn,
                        ]}
                        headers={[Tr('column_lp'), Tr('user_data'), ""]}
                        items={memberData.users.map((item, index) => [
                            (index + 1),
                            getUserFullNameWithEmail(item),
                            coordinatorView ? '' : <WorkableIconDeleteButton
                                disabled={rejected}
                                working={deleteWorkingId === item.identity}
                                onClick={() => confirmComplex({
                                    onConfirm: () => doDelete(item),
                                    confirmText: Tr('confirm_delete'),
                                    confirmText2: `${item.firstName} ${item.lastName}`,
                                    translateConfirmTexts: false
                                })}/>
                        ])}
                    />
            }
            {
                addPopup && <AddMemberUserPopup groupId={groupId} memberId={member.identity} onClose={() => setAddPopup(false)}/>
            }
            <div className={classes.section}>
                <GridBlock alignItems="center">
                    {
                        memberData.canConfirm && <>
                            {
                                !memberData.confirmationDate ?
                                    <WorkableButton disabled={!editable || participationWorking} working={participationWorking} Icon={CheckCircleOutlineIcon}
                                                    onClick={confirmParticipation}>{Tr("purchase_group_member_confirm_participation")}</WorkableButton> :

                                    <WorkableButton disabled={!editable || participationWorking} working={participationWorking} Icon={CancelIcon}
                                                    variant="outlined"
                                                    onClick={withdrawParticipation}>{Tr("purchase_group_member_withdraw_participation")}</WorkableButton>
                            }
                        </>
                    }
                    {
                        !!memberData.confirmationDate && <BoldTypography className={classes.success}>{Tr("purchase_group_member_participation_confirmed")}</BoldTypography>
                    }
                </GridBlock>
            </div>

        </TitledComponent>

        <MembersDocumentsList
            groupId={groupId}
            editable={editable && !rejected}
            coordinatorView={coordinatorView}
            membersDocs={memberData.memberDocuments}
            memberId={member.identity}
            validationSection={validationSection}
        />

    </div>)
}

MembersElementContent.propTypes = {}

export default connect((state, {member}) => ({
    memberData: state.resources[PurchasingGroupStage1Service.PURCHASING_GROUP_MEMBER_RESOURCE_ID(member.identity)],
    stage1Sections: state.resources[PurchasingGroupSectionService.PURCHASING_GROUP_STAGE_SECTIONS_RESOURCE_ID],
}), {})(MembersElementContent);